module.exports = __webpack_public_path__ + "static/media/golfer-8-a.182dcaf8.png";